export default __webpack_public_path__ + "static/B0044-2eafe737ba5360ea561a1bbe6a5b4ec3.png";